var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-service-list"},[_c('LbTable',{attrs:{"data":_vm.data,"columns":_vm.columns,"row-id-fn":_vm.rowIdFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }